import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ModalContainer } from '@containers/layout';
import { Box, Button, Text } from '@components/common';
import AnimatedTabs from '@components/AnimatedTabs';
import SvgIcon from '@components/SvgIcon';
import DialogBox from '@components/DialogBox';
import theme from '@styles/theme';

const List = styled(Box)`
  &::-webkit-scrollbar {
    width: 6px;
    background: ${theme.colors.secondary};
  }
  &::-webkit-scrollbar-thumb {
    width: 100%;
    border-radius: 30px;
    background: ${theme.colors.black};
  }
`;

const Item = styled(Box)`
  grid-template-columns: auto auto;
`;

const ItemContent = styled(Box)`
  grid-row-gap: ${theme.space[1]}px;
`;

const SERVICE_DESCRIPTIONS = [
  {
    Title: 'Move-Out',
    services: [
      {
        heading: 'Scrub Kitchen'
      },

      {
        heading: 'Scrub Bathroom'
      },

      {
        heading: 'Vacuum & Sweep'
      },

      {
        heading: 'Mop Floors'
      },

      {
        heading: 'Detailed Dusting'
      },

      {
        heading: 'Clean Baseboards'
      },

      {
        heading: 'Wipe-Down Appliances'
      },

      {
        heading: 'Empty Trash'
      },

      {
        heading: 'Interior Window Cleaning'
      },

      {
        heading: 'Oven Cleaning'
      },

      {
        heading: 'Refrigerator Cleaning'
      }
    ]
  },
  {
    Title: 'Deep Clean',
    services: [
      {
        heading: 'Straighten Up'
      },
      {
        heading: 'Load Dishwasher'
      },
      {
        heading: 'Scrub Kitchen'
      },
      {
        heading: 'Make The Bed'
      },
      {
        heading: 'Scrub Bathroom'
      },
      {
        heading: 'Vacuum And Sweep'
      },
      {
        heading: 'Mop Floors'
      },
      {
        heading: 'Detailed Dusting'
      },
      {
        heading: 'Clean Baseboards'
      },
      {
        heading: 'Wipe-Down Appliances'
      },
      {
        heading: 'Scrub Shower'
      },
      {
        heading: 'Vacuum Upholstery'
      },
      {
        heading: 'Take-Out Trash'
      }
    ]
  }
];

function MoveOutModal(props) {
  const { show, onDismiss, onSubmit } = props;
  const [activeTabIndex, changeActiveTabIndex] = useState(0);

  const selectedService = SERVICE_DESCRIPTIONS[activeTabIndex];

  const { services } = selectedService;

  return (
    <DialogBox
      show={show}
      onClickOutside={onDismiss}
      flexDirection="column"
      justifyContent="flex-start"
      pt={[7, 8]}
      pb={5}
    >
      <ModalContainer>
        <Box display="flex" flexDirection="column" my={4}>
          <AnimatedTabs
            segments={['Move-Out', 'Deep clean']}
            size="big"
            selectedIndex={activeTabIndex}
            onChange={(val, index) => {
              changeActiveTabIndex(index);
            }}
          />

          <List overflow="auto">
            {services.map((obj, index) => (
              <Item
                display="grid"
                key={index}
                mt={4}
                alignItems="baseline"
                justifyContent="flex-start"
              >
                <SvgIcon name="leaf" width={16} height={16} pr={1} mt={1} />
                <ItemContent display="grid" pr={2}>
                  <Text position="relative" fontSize={2} color="primary">
                    {obj.heading}
                  </Text>
                  {obj.description && (
                    <Text fontSize={1} color="lightText">
                      {obj.description}
                    </Text>
                  )}
                </ItemContent>
              </Item>
            ))}
          </List>
          <Button width="100%" mt={20} onClick={onSubmit}>
            Book
          </Button>
          <Button width="100%" mt={2} variant="secondary" onClick={onDismiss}>
            Cancel
          </Button>
        </Box>
      </ModalContainer>
    </DialogBox>
  );
}

MoveOutModal.propTypes = {
  show: PropTypes.bool,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func
};

export default MoveOutModal;
